import { render, staticRenderFns } from "./index-xietong.vue?vue&type=template&id=621f0675&scoped=true"
import script from "./index-xietong.vue?vue&type=script&lang=js"
export * from "./index-xietong.vue?vue&type=script&lang=js"
import style0 from "./index-xietong.vue?vue&type=style&index=0&id=621f0675&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621f0675",
  null
  
)

export default component.exports